import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CogIcon = ({
  width = normalize(24),
  height = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMin meet"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M13.752 20H12.24a1.344 1.344 0 0 1-1.344-1.344v-.872a.272.272 0 0 0-.176-.232.304.304 0 0 0-.328 0l-.592.64a1.335 1.335 0 0 1-1.896 0L6.808 17.12a1.328 1.328 0 0 1-.4-.952c0-.363.144-.71.4-.968l.592-.592a.272.272 0 0 0 0-.296c-.048-.12-.128-.208-.24-.208h-.816A1.352 1.352 0 0 1 5 12.752V11.24a1.344 1.344 0 0 1 1.344-1.344h.872a.272.272 0 0 0 .232-.176.304.304 0 0 0 0-.328l-.64-.592a1.336 1.336 0 0 1 0-1.896L7.88 5.808a1.32 1.32 0 0 1 .944-.4 1.376 1.376 0 0 1 .976.4l.592.592a.272.272 0 0 0 .296 0c.12-.048.208-.128.208-.24v-.816A1.352 1.352 0 0 1 12.248 4H13.8a1.344 1.344 0 0 1 1.344 1.344v.872a.272.272 0 0 0 .176.232.304.304 0 0 0 .328 0l.552-.64a1.336 1.336 0 0 1 1.896 0l1.096 1.072a1.337 1.337 0 0 1 .4.952 1.304 1.304 0 0 1-.4.968l-.592.592a.272.272 0 0 0 0 .296c.048.12.128.208.24.208h.872A1.352 1.352 0 0 1 21 11.248V12.8a1.344 1.344 0 0 1-1.344 1.344h-.872a.272.272 0 0 0-.232.176.272.272 0 0 0 0 .296l.616.616a1.335 1.335 0 0 1 0 1.896l-1.048 1.064a1.32 1.32 0 0 1-.944.4 1.376 1.376 0 0 1-.952-.4l-.616-.592a.272.272 0 0 0-.296 0c-.12.048-.208.128-.208.24v.872A1.352 1.352 0 0 1 13.752 20Zm-1.256-1.6h1.008v-.616a1.864 1.864 0 0 1 1.168-1.712 1.888 1.888 0 0 1 2.072.376l.432.432.704-.704-.432-.44a1.873 1.873 0 0 1-.384-2.048 1.864 1.864 0 0 1 1.712-1.16h.624v-1.032h-.616a1.864 1.864 0 0 1-1.712-1.168 1.888 1.888 0 0 1 .376-2.072l.432-.432-.704-.704-.44.432a1.912 1.912 0 0 1-3.2-1.336V5.6h-1.04v.616a1.864 1.864 0 0 1-1.168 1.712 1.888 1.888 0 0 1-2.072-.376l-.432-.432-.704.704.432.44a1.912 1.912 0 0 1-1.336 3.2H6.6v1.008h.616a1.864 1.864 0 0 1 1.712 1.168 1.888 1.888 0 0 1-.376 2.072l-.432.432.704.704.44-.432a1.912 1.912 0 0 1 3.2 1.336l.032.648Z" />
      <Path d="M13 15a3 3 0 1 1 0-5.999A3 3 0 0 1 13 15Zm0-4.286a1.285 1.285 0 1 0 0 2.571 1.285 1.285 0 0 0 0-2.57Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path
          fill={theme.colors["neutral.white"]}
          transform="translate(.9)"
          d="M0 0h24v24H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default CogIcon;
